import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=418e6a17&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"
import style0 from "./Start.vue?vue&type=style&index=0&id=418e6a17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418e6a17",
  null
  
)

export default component.exports